import { render, staticRenderFns } from "./ScoutTopicRecommendation.vue?vue&type=template&id=fc79e1a4"
import script from "./ScoutTopicRecommendation.vue?vue&type=script&lang=js"
export * from "./ScoutTopicRecommendation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports